import api from 'api';

export const SEARCH_BG_TEMPLATES_ASYNC_ACTION_START = 'SEARCH_BG_TEMPLATES_ASYNC_ACTION_START';
export const SEARCH_BG_TEMPLATES_ASYNC_ACTION_SUCCESS = 'SEARCH_BG_TEMPLATES_ASYNC_ACTION_SUCCESS';
export const SEARCH_BG_TEMPLATES_ASYNC_ACTION_ERROR = 'SEARCH_BG_TEMPLATES_ASYNC_ACTION_ERROR';
export const SEARCH_BG_TEMPLATES_RESET_STATE = 'SEARCH_BG_TEMPLATES_RESET_STATE';
export const SEARCH_BG_TEMPLATES_DEBOUNCE = 'SEARCH_BG_TEMPLATES_DEBOUNCE';
export const SEARCH_BG_RESULT_TEMPLATES_SEARCH_KEY_VAL = 'SEARCH_BG_RESULT_TEMPLATES_SEARCH_KEY_VAL';

function searchBgDesignTemplatesAsyncActionStart() {
  return {
    type: SEARCH_BG_TEMPLATES_ASYNC_ACTION_START,
  };
}

function searchBgDesignTemplatesAsyncActionError(error) {
  return {
    type: SEARCH_BG_TEMPLATES_ASYNC_ACTION_ERROR,
    error,
  };
}

function searchBgDesignTemplatesAsyncActionSuccess(data) {
  return {
    type: SEARCH_BG_TEMPLATES_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function resetsearchBgDesignTemplatesState() {
  return {
    type: SEARCH_BG_TEMPLATES_RESET_STATE,
  };
}

export function setSearchBackgroundKeyVal(data) {
  return {
    type: SEARCH_BG_RESULT_TEMPLATES_SEARCH_KEY_VAL,
    data,
  };
}

function handleBgTemplates(uri, searchKey) {
  const thunk = (dispatch, getState) => {
    dispatch(searchBgDesignTemplatesAsyncActionStart());
    return api.request(
      uri,
      'get',
    )
      .then((data) => {
        let curSearchKey = getState().searchBgDesignTemplates.get('sortKey');
        if (curSearchKey === searchKey) {
          dispatch(searchBgDesignTemplatesAsyncActionSuccess(data));
          return data;
        } else {
          return null;
        }

      })
      .catch((err) => {
        dispatch(searchBgDesignTemplatesAsyncActionError('Unable to search design templates'));
        throw (err);
      });
  };

  thunk.meta = {
    debounce: {
      time: 500,
      key: SEARCH_BG_TEMPLATES_DEBOUNCE,
    },
  };
  return thunk;
}

export function getsearchBgDesignTemplates(designTypeId, designSizeId, searchKey) {
  return handleBgTemplates(`design/searchbg?designtid=${designTypeId}&sizeid=${designSizeId}&searchkey=${searchKey}`, searchKey);
}

export function getsearchBgThemeDesignTemplates(searchKey) {
  return handleBgTemplates(`design/searchbg?searchkey=${searchKey}`, searchKey);
}
